import { render, staticRenderFns } from "./IdenticalProductsForm.vue?vue&type=template&id=7df70980&scoped=true&"
import script from "./IdenticalProductsForm.vue?vue&type=script&lang=js&"
export * from "./IdenticalProductsForm.vue?vue&type=script&lang=js&"
import style0 from "./IdenticalProductsForm.vue?vue&type=style&index=0&id=7df70980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df70980",
  null
  
)

export default component.exports